'use client';

import { c as _c } from "react/compiler-runtime";
import { useFetchAlbums } from "../../_hooks/useFetchAlbums";
import DpAlbumView from "./DpAlbumView";
import DpGalleryNew from "./DpGalleryNew";
import { Skeleton } from "@mui/material";
import Image from "next/image";
import GalleryFilters from "./GalleryFilters";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
export default function DpColumnView(t0) {
  const $ = _c(5);
  const {
    digitalProfile,
    isPreviewLeadGenProfile
  } = t0;
  const sitePhotoCount = Number(digitalProfile?.site_photo_count ?? 0);
  const showEmptyState = sitePhotoCount === 0;
  let t1;
  if ($[0] !== digitalProfile || $[1] !== isPreviewLeadGenProfile || $[2] !== showEmptyState || $[3] !== sitePhotoCount) {
    t1 = <div className="flex flex-col bg-white md:flex-1">{showEmptyState ? <div className="min-h-[70vh] flex flex-col items-center justify-center gap-2 text-center"><Image src="/assets/no_items.svg" alt="No photos available" width={80} height={80} /><p className="m3-body-medium text-[--textSecondarySecondary]">No Items Available</p></div> : <><div className={`flex flex-col md:flex-row md:align-middle mb-4 md:border md:border-[--colorDisabledOnColorDisabled] md:rounded-[100] sticky md:relative ${isPreviewLeadGenProfile ? "top-0" : "top-[64px]"} md:top-0 z-40 bg-white md:overflow-hidden`}><div className="whitespace-nowrap flex items-center pr-4 m3-title-small md:border-r md:border-[--colorDisabledOnColorDisabled] px-4 py-3"><ImageOutlinedIcon /> {sitePhotoCount} Site Photos</div><GalleryFilters digitalProfile={digitalProfile} isPreviewLeadGenProfile={isPreviewLeadGenProfile} /></div><div className="md:relative md:flex-1 md:min-h-[70vh]"><div className="min-h-[70vh] md:absolute md:inset-0 md:min-h-0 md:border md:border-[--colorDisabledOnColorDisabled] md:rounded-[28] md:overflow-hidden md:overflow-y-auto md:no-scrollbar"><DpGalleryNew digitalProfile={digitalProfile} isPreviewLeadGenProfile={isPreviewLeadGenProfile} /></div></div></>}</div>;
    $[0] = digitalProfile;
    $[1] = isPreviewLeadGenProfile;
    $[2] = showEmptyState;
    $[3] = sitePhotoCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}